import httpClient from './httpClient';
import type {
  UserListItem,
  UserDetail,
  CreateUserRequest,
  UpdateUserRequest,
  UserFilters,
  AuditLogItem,
  AuditLogFilters,
} from '@/types/admin';
import type { PaginatedResult } from '@/types';

export async function getUsers(acqFilters: UserFilters): Promise<PaginatedResult<UserListItem>> {
  const acqParams: Record<string, string | number | boolean> = {
    page: acqFilters.page,
    pageSize: acqFilters.pageSize,
  };
  if (acqFilters.search) acqParams.search = acqFilters.search;
  if (acqFilters.role) acqParams.role = acqFilters.role;
  if (acqFilters.isActive !== undefined) acqParams.isActive = acqFilters.isActive;

  const acqResponse = await httpClient.get<PaginatedResult<UserListItem>>('/users', { params: acqParams });
  return acqResponse.data;
}

export async function getUserById(acqId: string): Promise<UserDetail> {
  const acqResponse = await httpClient.get<UserDetail>(`/users/${acqId}`);
  return acqResponse.data;
}

export async function createUser(acqData: CreateUserRequest): Promise<UserDetail> {
  const acqResponse = await httpClient.post<UserDetail>('/users', acqData);
  return acqResponse.data;
}

export async function updateUser(acqData: UpdateUserRequest): Promise<UserDetail> {
  const acqResponse = await httpClient.put<UserDetail>(`/users/${acqData.id}`, acqData);
  return acqResponse.data;
}

export async function toggleUserActive(acqId: string): Promise<void> {
  await httpClient.post(`/users/${acqId}/toggle-active`);
}

export async function resetUserPassword(acqId: string): Promise<{ newPassword: string }> {
  const acqResponse = await httpClient.post<{ newPassword: string }>(`/users/${acqId}/reset-password`);
  return acqResponse.data;
}

export async function getRoles(): Promise<string[]> {
  const acqResponse = await httpClient.get<string[]>('/users/roles');
  return acqResponse.data;
}

export async function getAuditLogs(acqFilters: AuditLogFilters): Promise<PaginatedResult<AuditLogItem>> {
  const acqParams: Record<string, string | number> = {
    page: acqFilters.page,
    pageSize: acqFilters.pageSize,
  };
  if (acqFilters.search) acqParams.search = acqFilters.search;
  if (acqFilters.entityName) acqParams.entityName = acqFilters.entityName;
  if (acqFilters.userId) acqParams.userId = acqFilters.userId;
  if (acqFilters.dateFrom) acqParams.dateFrom = acqFilters.dateFrom;
  if (acqFilters.dateTo) acqParams.dateTo = acqFilters.dateTo;

  const acqResponse = await httpClient.get<PaginatedResult<AuditLogItem>>('/audit-logs', { params: acqParams });
  return acqResponse.data;
}
